import React from 'react';

const Twitter = (props: any) => (
  <span {...props}>
    {/* <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#000" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C15.5312 0 20 4.46875 20 10C20 15.5312 15.5312 20 10 20C4.46875 20 0 15.5312 0 10C0 4.46875 4.46875 0 10 0Z"
        fill="white"
      />
      <path
        d="M13.2006 5H14.9044L11.1821 9.2359L15.5611 15H12.1324L9.44694 11.5041L6.37416 15H4.66936L8.65067 10.4692L4.44995 5H7.96567L10.3931 8.19538L13.2006 5ZM12.6026 13.9846H13.5467L7.45267 5.96206H6.43956L12.6026 13.9846Z"
        fill="#0D0D0E"
      />

    </svg> */}
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#000" />
      <g transform="translate(10 10) scale(0.6) translate(-12 -12)">
        <path
          d="M21.742 21.75l-7.563-11.179 7.056-8.321h-2.456l-5.691 6.714-4.54-6.714H2.359l7.29 10.776L2.25 21.75h2.456l6.035-7.118 4.818 7.118h6.191-.008zM7.739 3.818L18.81 20.182h-2.447L5.29 3.818h2.447z"
          fill="#fff"
        />
      </g>
    </svg>

  </span>
);

export default Twitter;
